import { NgModule } from '@angular/core';
import { SharedModule } from './../../../shared/modules/shared.module';
import { AnnualRenewalComponent } from './annual-renewal.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule,
    NgxMaskDirective
  ],
  declarations: [
    AnnualRenewalComponent
  ],
  providers: [ provideNgxMask()]
})
export class AnnualRenewalModule { }
